module.exports = __webpack_public_path__ + "img/pr-3.d204c863.png";